import CarouselByType from '../../../../../pages/vip/features/recommendations/carousel-byType';

export default CarouselByType;
